const trainNumbers = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/train-numbers/train-numbers.html',
  controller: 'TrainNumbersController',
};

angular
  .module('pis-tool.module')
  .component('trainNumbers', trainNumbers)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.trainNumbers', {
          url: '/train-numbers',
          views: {
              'pisview@pis': 'trainNumbers',
          },
      });
  });
